export default __webpack_public_path__ + "static/RC_how_we_do_it_icons-04-fe666d92c05a4b1131ae557b7bae8c37.png";